import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractRowTemplate from "./AbstractRowTemplate.js";
import TextRow from "../../reports/rows/TextRow.js";
import TranslatedString from "../../../TranslatedString.js";

/**
 * Text row template.
 * Supported styles: heading, subheading, text, highlight.
 *
 * @param {TranslatedString} title - Title of the row
 * @param {string} [style] - Style used to display the title.
 */
export default class TextRowTemplate extends AbstractRowTemplate {
	constructor({ title, style } = {}) {
		super(...arguments);

		this._title = title;
		this._style = style || this._getDefaultStyle();
	}

	getTitle() {
		return this._title;
	}

	setTitle(title) {
		this._title = title;
	}

	getStyle() {
		return this._style;
	}

	setStyle(style) {
		this._style = style;
	}

	accept(visitor) {
		return visitor.visitTextRowTemplate(this);
	}

	_instanceClass() {
		return TextRow;
	}

	_interpretationSpec() {
		const spec = super._interpretationSpec(...arguments);

		spec.title = this._title;
		spec.style = this._style;

		return spec;
	}

	_getDefaultStyle() {
		return "heading";
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.title = this._title;
		properties.style = this._style;

		return properties;
	}

	static getLabel() {
		return _("Text row");
	}

	static getType() {
		return "TextRowTemplate";
	}

	static transformMaterializationData(data, context) {
		data.title = TranslatedString.materialize(data.title, context);
	}
}
